import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Esto es un plan de dieta?',
    a: 'No. El Método del 1% no se trata de restricción. Se trata de tiempos estratégicos, nutrición y cambios de estilo de vida que apoyan tus hormonas de forma natural.'
  }, {
    q: '¿Qué tan pronto veré resultados?',
    a: 'Muchas mujeres reportan más energía y menos hinchazón en los primeros 7 a 10 días. Un balance hormonal más profundo suele tomar entre 1 y 3 ciclos (30 a 90 días) de práctica constante.'
  }, {
    q: '¿Necesito comprar suplementos costosos?',
    a: 'Para nada. El método se basa completamente en alimentos, luz natural y hábitos de vida que son totalmente gratuitos. No necesitas invertir en suplementos para obtener resultados.'
  }, {
    q: '¿Es adecuado para la menopausia o perimenopausia?',
    a: 'Sí. Los principios fundamentales de balance de glucosa, ritmo circadiano y manejo del estrés aplican a mujeres en todas las etapas de la vida.'
  }, {
    q: '¿Cómo accedo al material?',
    a: 'Al comprar, recibirás un correo con acceso inmediato para descargar el e-book en tu teléfono, tablet o computadora. Es tuyo de por vida.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-cream" data-id="element-99">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-100">
        <div className="text-center mb-10 md:mb-14" data-id="element-101">
          <FadeIn data-id="element-102">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-103">
              Resuelve tus dudas
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-104">
              ¿Preguntas <em className="italic" data-id="element-105">frecuentes?</em>
            </h2>
          </FadeIn>
        </div>

        <div className="space-y-2" data-id="element-106">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-107">
              <div className="border-b border-ink/10" data-id="element-108">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full py-5 md:py-6 flex items-center justify-between text-left focus:outline-none group gap-4" data-id="element-109">
                  <span className="font-serif text-lg md:text-xl text-ink group-hover:text-sand-dark transition-colors" data-id="element-110">
                    {faq.q}
                  </span>
                  <span className="flex-shrink-0 text-ink-light" data-id="element-111">
                    {openIndex === index ? <Minus className="w-5 h-5" data-id="element-112" /> : <Plus className="w-5 h-5" data-id="element-113" />}
                  </span>
                </button>

                <AnimatePresence data-id="element-114">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-115">
                      <p className="pb-6 text-base text-ink-light font-light leading-relaxed" data-id="element-116">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}